module.exports = __webpack_public_path__ + "img/新战略·星启程星链数据2021年度成绩单.f4e6ee3b.png";